import React, { FC } from 'react'
import { HashRouter as Router, Route, Routes } from 'react-router-dom'
import styled from '@emotion/styled'
import { Web3ReactProvider } from '@web3-react/core'

import { FeatureMain, Footer, Header } from 'components'
import { FeatureStateProvider } from 'state-provider'
import { Home } from 'modules/home'
import { NftDetail } from 'modules/NftDetail'
import { LoginModalProvider } from 'shared/providers'
import { getLibrary } from 'wallet/web3'

import { SingleNft } from 'modules/upload/single_nft'
import { MultipleNFT } from 'modules/upload/multiple_nft'
import { NotFound } from 'modules/not-found'
import { NftEdit } from 'modules/edit'

const Content: FC = () => {
    return (
        <div>
            <Header />
            <Main className="mx-auto my-0">
                <Routes>
                    <Route path="/upload" element={<SingleNft />} />
                    <Route path="/upload/multiple" element={<MultipleNFT />} />
                    <Route path="/nft/:id/edit" element={<NftEdit />} />
                    <Route path="/nft/:id" element={<NftDetail />} />
                    <Route path="/" element={<Home />} />
                    <Route index element={<Home />} />
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </Main>
            <Footer />
        </div>
    )
}

const App: FC = () => {
    return (
        <FeatureStateProvider>
            <LoginModalProvider>
                <Web3ReactProvider getLibrary={getLibrary}>
                    <FeatureMain>
                        <Router>
                            <Content />
                        </Router>
                    </FeatureMain>
                </Web3ReactProvider>
            </LoginModalProvider>
        </FeatureStateProvider>
    )
}

export default App

const Main = styled.main`
    width: 100%;
    min-height: calc(100vh - 68px - 90px);
`
